<!--
 Created by Xuz on 2019/02/20.
 xuz[at]live[dot]cn
 权限编辑
-->
<template>
    <a-modal title="编辑权限"
             :width="800"
             :visible="visible"
             :maskClosable="false"
             @ok="onEditPermSubmit"
             @cancel="onCancel"
             :confirmLoading="modalLoading.editPerm">
        <a-form :form="editPermForm">
            <a-form-item label='上级权限'
                         :labelCol="{ span: 5 }"
                         :wrapperCol="{ span: 12 }">
              <a-tree-select v-model="modalData.editPerm.parentId" :treeData="permList" treeDefaultExpandAll allowClear/>
            </a-form-item>
            <a-form-item
                    label='权限名称'
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 12 }">
                <a-input v-decorator="[
                            'name',
                            {initialValue:modalData.editPerm.name, rules: [{ required: true, message: '请填写权限名称' }]}]" placeholder='权限名称'/>
            </a-form-item>
            <a-form-item
                    label='关键字'
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 12 }">
                <a-input v-decorator="[
                            'keyword',
                            {initialValue:modalData.editPerm.keyword, rules: [{ required: true, message: '请填写关键字' }]}]" placeholder='关键字'/>
            </a-form-item>
            <a-form-item
                    label='顺序号'
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 12 }">
                <a-input-number v-decorator="[
                                    'sort',
                                    {initialValue:modalData.editPerm.sort, rules: [{ required: true, type: 'number', message: '请填写数字类型顺序号' }]}]" placeholder='顺序号'/>
            </a-form-item>
            <a-form-item
                    label='描述'
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 12 }">
                <a-input v-decorator="[
                            'description',
                            {initialValue:modalData.editPerm.description, rules: [{ required: false, message: '请填写描述' }]}]" placeholder='描述'/>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import qs from 'qs'

export default {
  name: 'PermEdit',
  props: {
  },
  data () {
    return {
      editPermForm: this.$form.createForm(this),
      visible: false,
      modalLoading: {
        editPerm: false
      },
      permList: [],
      modalData: {
        editPerm: {
          id: null,
          parentId: null,
          parentName: null
        }
      }
    }
  },
  methods: {
    prePermEdit (permId) {
      const that = this
      this.visible = true
      this.modalLoading.editPerm = true
      that.$http.get('/api/1/perm/perm_full_list.json').then(function (resp) {
        let result = []
        that.mapTreeSelectData(result, resp.result, [permId])
        that.permList = result
      })
      this.$http.get('/api/1/perm/get_perm.json?id=' + permId).then(function (response) {
        let perm = response.result
        that.modalData.editPerm.id = perm.id
        that.modalData.editPerm.parentId = perm.parentId
        that.editPermForm.setFieldsValue({ name: perm.name, keyword: perm.keyword, sort: perm.sort, description: perm.description })

        that.modalLoading.editPerm = false

        if (perm.parentId !== '') {
          that.$http.get('/api/1/perm/get_perm.json?id=' + perm.parentId).then(function (response) {
            let perm = response.result
            that.modalData.editPerm.parentName = perm.name
          })
        }
      })
    },
    onEditPermSubmit () {
      let that = this
      this.editPermForm.validateFields((err, values) => {
        if (err) {
          return
        }
        let params = this.editPermForm.getFieldsValue()
        params.id = this.modalData.editPerm.id
        params.parentId = this.modalData.editPerm.parentId
        params.deptId = this.modalData.editPerm.deptId
        params.orgId = this.modalData.editPerm.orgId
        this.modalLoading.editPerm = true
        this.$http.post('/api/1/perm/edit_perm.json', qs.stringify(params)).then(function (resp) {
          that.visible = false
          that.$message.success('操作成功')
          that.editPermForm.resetFields()
          that.modalLoading.editPerm = false
          that.$emit('success', resp.result.parentId, resp.result.srcParentId)
        })
      })
    },
    onCancel () {
      this.visible = false
    },
    mapTreeSelectData (result, list, skipIds) {
      const that = this
      if (!list) {
        return
      }
      list.forEach(function (item) {
        if (!skipIds.includes(item.id)) {
          let o = { value: item.id, title: item.name, children: [] }
          that.mapTreeSelectData(o.children, item.children, skipIds)
          result.push(o)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
